import { PanelRightDashed } from "lucide-react";
import { useTranslation } from "react-i18next";
import { useSidebarShallowStore } from "../../store/sidebar-store";
import { type PageHeaderAction } from "../../components/PageHeader";

export const useReopenSidebarAction = (enduserId: string): PageHeaderAction | undefined => {
  const { t } = useTranslation("contacts");
  const { isOpen, openSidebar } = useSidebarShallowStore("isOpen", "openSidebar");

  if (isOpen) return undefined;

  const action: PageHeaderAction & { "data-trackingid": string } = {
    icon: PanelRightDashed,
    label: t("Open details panel"),
    onClick: () => openSidebar("ContactDetails", { enduserId }),
    "data-trackingid": "contact-details-takeover-reopen-sidebar",
  };

  return action;
};
